import isObject from 'lodash/isObject';
import isEmpty from 'lodash/isEmpty';

// eslint-disable-next-line import/prefer-default-export
export function mapApiError(error) {
  if (!isObject(error) && isEmpty(error)) return undefined;
  return error.response;
}
